module.exports = __webpack_public_path__ + "img/shroud-photo.56fbe7b8.png";